import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

 const StyledBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing( 14, 0),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing( 8, 0),
    },  
    '& .UTRSTextContainer':{
      maxWidth: theme.spacing(100),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'self-start',
      gap:theme.spacing(4),    
      marginBottom: theme.spacing(8), 
    },
    '& .UTRImageContainer':{
        width: '100%',
        height: theme.typography.pxToRem(738),
        [theme.breakpoints.down('md')]: {
        height: theme.typography.pxToRem(175),
        },  
    },
}));
export default StyledBox;